import { qsAll } from "./dom";

/** Shows exactly one `[data-step]` child of `root` at a time. Used for the
 *  amount -> review -> pending -> success/failed progression that Fund
 *  Wallet, Buy Electricity and Bill Centre all share. */
export function createStepController(root: HTMLElement) {
  const steps = qsAll<HTMLElement>("[data-step]", root);

  function show(stepName: string): void {
    steps.forEach((el) => {
      el.hidden = el.dataset.step !== stepName;
    });
  }

  return { show };
}
